import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBoxArchive = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M480 48H32c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16H48 464h16c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zm0 96H464 48 32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32zM160 232c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm304-56h16V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V176H48V416c0 26.5 21.5 48 48 48H416c26.5 0 48-21.5 48-48V176z" })
});
export default SvgBoxArchive;
